require("babel-polyfill");
/**
 *  Stile iFrame communication interface
 *
 *  No need to touch anything in here, all your scripts should be added to main.js instead.
 *
 *  Read docs/stileInterface.md for information on how to interact with Stile from your
 *  widget using this interface.
 **/

// Configure this iFrame to call your load function when Stile sends data.
let onLoadCallback = null;
function onStileLoad(callback) {
    if (onLoadCallback === null) {
        onLoadCallback = callback;
    } else {
        console.error("Load handler already set");
    }
}
let onHighScoresCallback = null;
function onHighScoreReceived(callback) {
    if (onHighScoresCallback === null) {
        onHighScoresCallback = callback;
    } else {
        console.error("HighScore handler already set");
    }
}

let onViewerCallback = null;
function onViewerStateReceived(callback) {
    if (onViewerCallback === null) {
        onViewerCallback = callback;
    } else {
        console.error("Viewer handler already set");
    }
}

// Global interface of callbacks for Stile to call.
const stileInterface = {
    getWindowDimensions: function (callback) {
        var body = document.body;
        var html = document.documentElement;

        var width = Math.max(
            body.scrollWidth,
            body.offsetWidth,
            html.clientWidth,
            html.scrollWidth,
            html.offsetWidth,
        );
        var height = width * 0.6;

        var dimensions = {
            width: width,
            height: height,
        };

        callback(null, dimensions);
    },
    load: function (callback, state) {
        // Loads the given state into the iFrame, if the simulation supports it.
        let loadPromise;
        if (typeof onLoadCallback === "function") {
            loadPromise = onLoadCallback(state);
        } else {
            console.error("No load handler configured by this simulation.");
        }
        // Allows Stile to run code after load finishes.
        if (loadPromise) {
            callback(null, loadPromise);
        } else {
            callback(
                generateErrorResponse(
                    "TypeError",
                    "This simulation doesn't know how to load.",
                ),
            );
        }
    },
    viewer: function (callback, viewerState) {
        // Provides information about the viewer to the iFrame
        // For now, just the current roles
        if (typeof onViewerCallback === "function") {
            onViewerCallback(viewerState);
        } else {
            console.error("No viewer handler configured by this simulation.");
        }
    },
    updateHigherscores: function (callback, scores) {
        console.log("updateHigherScores", arguments);
        if (typeof onHighScoresCallback === "function") {
            onHighScoresCallback(scores);
        } else {
            console.error(
                "No highscore handler configured by this simulation.",
            );
        }
    },
    endpointInfo: function (callback, endpointInfo) {
        // window.endpoints = endpointInfo.endpoints
        // window.defaultEndpoint = defaultEndpoint.defaultEndpoint;
    },
};

// Get the passed in source that for the iframe, used to filter the response to
// a single domain so we're not sending this to everyone.
var sourceOrigin = decodeURIComponent(document.location.hash.replace(/^#/, ""));

// Post the message back to the source frame.
function postSerializableData(data) {
    if (typeof data !== "object") {
        throw new TypeError("data should be an object");
    }
    window.parent.postMessage(JSON.stringify(data), sourceOrigin);
}

// Generate an error in our response object.
function generateErrorResponse(type, message) {
    return {
        error: true,
        errorType: type,
        errorText: message,
    };
}

function handleRPCCall(method, methodArguments, callId) {
    var methodCallback = stileInterface[method];
    function callback(err, response) {
        if (err) {
            postSerializableData({
                rpcCallId: callId,
                response: generateErrorResponse(err.name, err.message),
            });
            return;
        }

        postSerializableData({
            rpcCallId: callId,
            response: response,
        });
    }

    if (method === "getCapabilities") {
        callback(null, Object.keys(stileInterface));
    } else if (typeof methodCallback !== "function") {
        callback(
            generateErrorResponse(
                "NotImplemented",
                method + " has not been implemented",
            ),
        );
    } else {
        methodCallback.apply(null, [callback].concat(methodArguments));
    }
}

// Counter for unique ID to use for sending events to Stile
var eventCallIdCounter = 0;
function sendStileEventCall(eventName, eventArguments) {
    var callId = "event" + eventCallIdCounter++;
    postSerializableData({
        eventCallId: callId,
        event: eventName,
        eventArguments: eventArguments,
    });
}

// Maps RPC IDs to promises for their eventual success or failure.
var pendingRpcRequests = {};
var rpcIdCounter = 0;
function sendStileRpcCall(rpcName, rpcArguments) {
    console.log("sendStileRpcCall");
    var callId = "rpc" + rpcIdCounter++;
    var replyPromise = new Promise((resolve, reject) => {
        pendingRpcRequests[callId] = { resolve, reject };
    });
    postSerializableData({
        frameCallId: callId,
        rpc: rpcName,
        rpcArguments: rpcArguments,
    });
    return replyPromise;
}

window.addEventListener(
    "message",
    function (event) {
        // If the message wasn't from the source provided initially then
        // ignore the message.
        if (event.origin !== sourceOrigin) return;

        var eventData = JSON.parse(event.data);

        if (eventData.frameCallId !== undefined) {
            if (pendingRpcRequests[eventData.frameCallId] === undefined) {
                console.log("Reply to expired message", eventData);
                return;
            }
            if (eventData.successful) {
                pendingRpcRequests[eventData.frameCallId].resolve(
                    eventData.response,
                );
            } else if (eventData.successful === false) {
                pendingRpcRequests[eventData.frameCallId].reject(
                    eventData.error,
                );
            } else {
                console.log("Malformed response", eventData);
            }
            delete pendingRpcRequests[eventData.frameCallId];
        } else {
            handleRPCCall(
                eventData.method,
                eventData.rpcArguments,
                eventData.rpcCallId,
            );
        }
    },
    false,
);

module.exports = {
    stileInterface,
    sendStileEventCall,
    sendStileRpcCall,
    onStileLoad,
    onHighScoreReceived,
    onViewerStateReceived,
};
